import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { FiDownload, FiUpload } from "react-icons/fi";
import { AiOutlineFileSync } from "react-icons/ai";
import { Heading, Label } from "./styled/StyledStepper.styled";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 37,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#006F35",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#006F35",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 65,
  height: 65,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#006F35",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#006F35",
  }),
}));

const ColorlibStepIconParent = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 75,
  height: 75,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    border: "1px solid #006F35",
    backgroundColor: "#ffffff",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#ffffff",
    width: 65,
    height: 65,
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <FiDownload size={25} />,
    2: <FiUpload size={25} />,
    3: <AiOutlineFileSync size={25} />,
  };

  return (
    <ColorlibStepIconParent
      ownerState={{ completed, active }}
      className={className}
    >
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    </ColorlibStepIconParent>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const steps = ["Download Template", "Upload Document", "Processing"];

export default function StyledStepper(props) {
  return (
    <div style={{ marginTop: "30px" }}>
      <Stepper
        alternativeLabel
        activeStep={props.active}
        connector={<ColorlibConnector />}
      >
        {steps.map((label, i) => {
          let selected = false;
          let dynamicLabel = "";
          if (i === props.active) {
            selected = true;
          }
          if (i === 0) {
            dynamicLabel = props.label0;
          }
          if (i === 1) {
            dynamicLabel = props.label1;
          }
          if (i === 2) {
            dynamicLabel = props.label2;
          }
          return (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                <Heading selected={selected}>{label}</Heading>
                <Label>{dynamicLabel}</Label>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
